import axios from "axios";
import store from "../redux/store/index";
import { getURL } from "../constants/index";
import { puntToSignIn } from "./APIService";

export async function getLocationService(SiteID) {
  const WebAPI_URL = getURL();
  const state = store.getState();
  if (state.authReducer.user == null)
    puntToSignIn();
  const token = state.authReducer.user.profile.token;
  return new Promise((resolve, reject) => {
    const config = {
      method: "GET",
      url: WebAPI_URL + "api/Locids/GetLocationsBySiteID/" + SiteID,
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: "Bearer " + token,
      },
    };
    axios(config)
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export async function getLocationDetails() {
  const WebAPI_URL = getURL();
  const state = store.getState();
  if (state.authReducer.user == null)
    puntToSignIn();
  const token = state.authReducer.user.profile.token;
  return new Promise((resolve, reject) => {
    const config = {
      method: "GET",
      url: WebAPI_URL + "api/Locids/GetDetails",
      headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: "Bearer " + token,
      },
    };
    axios(config)
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
